import axios from "axios";

export const getIp = async () => {
    let myIp: string;
    try {
        const {data} = await axios.get('https://api.ipify.org?format=json');
        myIp = data.ip
    } catch (error) {
        myIp = '127.0.01'
    }
    
    return myIp
}
